import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createClothEntry = createAsyncThunk('createClothEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertCloth`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateClothEntry = createAsyncThunk('updateClothEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateCloth`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchClothData = createAsyncThunk('fetchClothData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getClothlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleCloth = createAsyncThunk('fetchSingleCloth', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getClothlist&clothId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleCloth = createAsyncThunk('deleteSingleCloth', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteCloth&clothId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const clothSlice = createSlice({
    name: 'ClothData',
    initialState: {
        isLoading: false,
        cloth: null,
        deleteCloth: null,
        singleCloth: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchClothData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchClothData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.cloth = action.payload;
        });
        builder.addCase(fetchClothData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleCloth.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleCloth.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteCloth = action.payload;
        });
        builder.addCase(deleteSingleCloth.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleCloth.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleCloth.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleCloth = action.payload;
        });
        builder.addCase(fetchSingleCloth.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default clothSlice.reducer;
